import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { getAuthToken } from "auth/authToken";
import { getAuthApi } from "config/config";

export type LoginSuccessResponse = { token: string };
export type LoginChallengeResponse = { challengeState: string; prompt: string };
export type LoginResponse = LoginSuccessResponse | LoginChallengeResponse;

export const isChallengeResponse = (response: LoginResponse): response is LoginChallengeResponse => "challengeState" in response;

type ApiResponse<T> = {
    success: boolean;
    message: string;
    data: T;
};

export type Role = {
    id: number | null;
    name: string | null;
    app: string | null;
    tenant: string | null;
};

const baseQuery = fetchBaseQuery({
    baseUrl: getAuthApi(),
});

export const authApi = createApi({
    reducerPath: "authApi",
    baseQuery,
    endpoints: (builder) => ({
        getMyEffectiveRoles: builder.query<ApiResponse<Role[]>, void>({
            query: () => ({
                url: `/admin/roles/effective/mine`,
                headers: {
                    authorization: `Bearer ${getAuthToken()}`,
                },
            }),
        }),
        login: builder.mutation<LoginResponse, { username: string; password: string }>({
            query: (credentials) => ({
                url: `/authentication`,
                method: "POST",
                body: credentials,
            }),
        }),
        continueAuthentication: builder.mutation<LoginResponse, { username: string; challengeState: string; challengeResponse: string }>({
            query: (request) => ({
                url: `/authentication/challenge`,
                method: "POST",
                body: request,
            }),
        }),
    }),
});

export const { useGetMyEffectiveRolesQuery, useLoginMutation, useContinueAuthenticationMutation } = authApi;
